import React, { FC, useEffect, useRef } from 'react';
import { Navigation } from '../Navigation';
import { HeaderContent } from './Header.styled';

export const Header: FC = () => {
  const headerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const header = headerRef.current;
    if (!header) return undefined;

    let frame = 0;
    const applyHeight = () => {
      document.documentElement.style.setProperty(
        '--app-header-height',
        `${header.getBoundingClientRect().height}px`,
      );
    };
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(applyHeight);
    };
    schedule();
    const resizeObserver = new ResizeObserver(schedule);
    resizeObserver.observe(header);
    const mutationObserver = new MutationObserver(schedule);
    mutationObserver.observe(header, { childList: true, subtree: true });
    return () => {
      cancelAnimationFrame(frame);
      resizeObserver.disconnect();
      mutationObserver.disconnect();
      document.documentElement.style.removeProperty('--app-header-height');
    };
  }, []);

  return (
    <HeaderContent ref={headerRef} data-testid="app-header">
      <Navigation />
    </HeaderContent>
  );
};
